"use client";

import { ListCard } from "@/components/shared/list-card";

/**
 * One of the house's suggestion lists as the one list card (canon §13): eyebrow "Lista de
 * sugestão", the curation's name and its description on the photograph. The homepage's row and
 * the creation's choice draw it; each says where it leads. A list without a photograph wears the
 * brand's cover placeholder.
 */
export function SuggestionListCard({
  name,
  description,
  imageSrc,
  href,
  className,
  onNavigate,
}: {
  name: string;
  description: string;
  imageSrc: string | null;
  href: string;
  className?: string;
  /** Called when the card is pressed, for the analytics; navigation is left alone. */
  onNavigate?: () => void;
}) {
  return (
    <ListCard
      eyebrow="Lista de sugestão"
      title={name}
      supportLine={description}
      coverSrc={imageSrc}
      href={href}
      optimizeCover
      onNavigate={onNavigate}
      className={className}
    />
  );
}
